const BannerMain = () => {
  return (
    <div className="slider" id="home">
      <h1 className="container-slider-title wow animate__animated animate__zoomIn">
        <span className="slider-title-1">LAVADERO</span>
        <span className="slider-title">AGÜITAS</span>
      </h1>
      <p className="slider-text">
        Las burbujas mas elegidas de la ciudad durante 25 años!
      </p>
    </div>
  );
};

export default BannerMain;
